<template>
  <b-card>
    <FormBuilder
      label="Pertanyaan&quot;"
      update
      :data="$store.state.question.detailData"
      :fields="fields"
      :loading-detail="$store.state.question.loadingDetail"
      :loading-submit="$store.state.question.loadingSubmit"
      @load="loadData"
      @submit="submitData"
      @reset="resetData"
    />
  </b-card>
</template>

<script>
import FormBuilder from '@/layouts/components/FormBuilder.vue'

import {
  BCard,
} from 'bootstrap-vue'

import fields from '@/field/form/question'

export default {
  components: {
    BCard,
    FormBuilder,
  },
  setup() {
    return {
      fields,
    }
  },
  methods: {
    loadData(id) {
      return this.$store.dispatch('question/getDetail', id)
    },
    submitData(id, data, callback) {
      this.$store.dispatch('question/update', {
        id,
        data,
      })
        .then(callback)
    },
    resetData() {
      return this.$store.commit('question/SET_DETAIL_DATA', undefined)
    },
  },
}
</script>

<style scoped>

</style>
